import { useEffect, useState } from 'react';

import { getWindowWidth } from 'utils/browsers';
import { breakpoints as breakpointsValues } from 'shared/static/breakpoints';

import { UseScreenServiceReturn } from './model.d';

export const useScreenService = (): UseScreenServiceReturn => {
  const [isSm, setIsSm] = useState<boolean>(false);
  const [isMd, setIsMd] = useState<boolean>(false);
  const [isMdUp, setIsMdUp] = useState<boolean>(false);
  const [isLg, setIsLg] = useState<boolean>(false);
  const [isLgUp, setIsLgUp] = useState<boolean>(false);
  const [isXl, setIsXl] = useState<boolean>(false);
  const [isXlUp, setIsXlUp] = useState<boolean>(false);
  const [isXxl, setIsXxl] = useState<boolean>(false);
  const [isMobile, setIsMobile] = useState<boolean>(false);

  const handleResize = () => {
    const width = getWindowWidth();
    setIsSm(width < breakpointsValues.sm);
    setIsMd(width >= breakpointsValues.sm && width < breakpointsValues.md);
    setIsMdUp(width >= breakpointsValues.sm);
    setIsLg(width >= breakpointsValues.md && width < breakpointsValues.lg);
    setIsLgUp(width >= breakpointsValues.lg);
    setIsXl(width >= breakpointsValues.lg && width < breakpointsValues.xl);
    setIsXlUp(width >= breakpointsValues.xl);
    setIsXxl(width >= breakpointsValues.xl);

    setIsMobile(width < breakpointsValues.md);
  };

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions,no-unused-expressions
    window && window.addEventListener('resize', handleResize);

    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return {
    isSm,
    isMd,
    isMdUp,
    isLg,
    isLgUp,
    isXl,
    isXlUp,
    isXxl,
    isMobile,
  };
};
